module.exports = __webpack_public_path__ + "img/li-zhang-K-DwbsTXliY-unsplash.be619800.jpg";